import { Vector } from '@inter-ikea-core/core';
/**
 * Calculates the distance between two vectors
 * @param start Start vector
 * @param end End vector
 * @returns Length
 */
export const getLineLength = (start, end) => {
    return Math.sqrt(Math.pow(end.x - start.x, 2.0) + Math.pow(end.y - start.y, 2.0) + Math.pow(end.z - start.z, 2.0));
};
/**
 * Calculates the center between two vectors
 * @param start Start vector
 * @param end  End vector
 * @returns Center vector
 */
export const getLineCenter = (start, end) => {
    return {
        x: (start.x + end.x) * 0.5,
        y: (start.y + end.y) * 0.5,
        z: (start.z + end.z) * 0.5
    };
};
export const mmToCm = (millimeter, round = false) => round ? Math.round(millimeter / 10) : millimeter / 10;
export const cmToMm = (cm) => cm * 10;
export const mmToInch = (millimeter, round = false) => round ? Math.round(millimeter * 0.0393701) : millimeter * 0.0393701;
export const inchToMm = (inch, round = false) => {
    return round ? Math.round((inch * 25.4) / 10) * 10 : inch * 25.4;
};
/**
 * Checks if given point is inside the given polygon
 * @param point The point
 * @param polygon The polygon represented by x and y values in a 2d plane
 * @returns Boolean indicating if point is inside polygon or not
 */
export function isPointInsidePolygon(point, polygon) {
    const x = point.x;
    const y = point.y;
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y;
        const intersect = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersect) {
            inside = !inside;
        }
    }
    return inside;
}
/**
 * Calculates the center of the polygon
 * @param points The polygon points
 * @returns Center of shape vector
 */
export function getPolygonCenter(polygon) {
    let xTot = 0;
    let yTot = 0;
    let zTot = 0;
    for (let i = 0; i < polygon.length; ++i) {
        xTot += polygon[i].x;
        yTot += polygon[i].y;
        zTot += polygon[i].z;
    }
    return { x: xTot /= polygon.length, y: yTot /= polygon.length, z: zTot /= polygon.length };
}
/**
 * Calculates the width of a polygon
 * @param points
 */
export function getPolygonWidth(polygon) {
    let xMax = 0;
    let xMin = 0;
    for (let i = 0; i < polygon.length; ++i) {
        if (i === 0) {
            xMin = polygon[i].x;
            xMax = polygon[i].x;
        }
        else {
            if (polygon[i].x > xMax)
                xMax = polygon[i].x;
            if (polygon[i].x < xMin)
                xMin = polygon[i].x;
        }
    }
    return xMax - xMin;
}
/**
 * Rotate a point in 2d space around a center point.
 * @param cx center x coordinate
 * @param cy center y coordinate
 * @param x position x coordinate
 * @param y position y coordinate
 * @param angle Specifies how much to rotate using a angle.
 * @returns An array with the new rotated x, y value
 */
export function rotatePointRoundCenterId2dSpace(cx, cy, x, y, angle) {
    const radians = (Math.PI / 180) * angle, cos = Math.cos(radians), sin = Math.sin(radians), nx = cos * (x - cx) + sin * (y - cy) + cx, ny = cos * (y - cy) - sin * (x - cx) + cy;
    return [nx, ny];
}
export const rotateStartAndEndVectorsRoundCenter = (groupCenter, start, end, rotation) => {
    const rotatedStartPoints = rotatePointRoundCenterId2dSpace(groupCenter.X, groupCenter.Z, start.X, start.Z, rotation);
    const rotatedEndPoints = rotatePointRoundCenterId2dSpace(groupCenter.X, groupCenter.Z, end.X, end.Z, rotation);
    const rotatedStart = new Vector(rotatedStartPoints[0], start.Y, rotatedStartPoints[1]);
    const rotatedEnd = new Vector(rotatedEndPoints[0], end.Y, rotatedEndPoints[1]);
    return { rotatedStart, rotatedEnd };
};
/**
 * Calculates the center between to vectors
 * @param v1 Vector 1
 * @param v2 Vector 2
 * @returns Center point
 */
export const getCenterBetweenVectors = (v1, v2) => {
    return new Vector((v1.X + v2.X) / 2, (v1.Y + v2.Y) / 2, (v1.Z + v2.Z) / 2);
};
export const getDistanceBetweenPoints = (pointA, pointB) => {
    try {
        return Math.sqrt(Math.pow(pointB.X - pointA.X, 2) +
            Math.pow(pointB.Y - pointA.Y, 2) +
            Math.pow(pointB.Z - pointA.Z, 2));
    }
    catch (error) {
        return;
    }
};
export const calculateCenter = (vectors) => {
    if (vectors.length > 0) {
        // Initialize sum of coordinates
        let sumX = 0;
        let sumY = 0;
        let sumZ = 0;
        // Sum all coordinates
        for (const v of vectors) {
            sumX += v.X;
            sumY += v.Y;
            sumZ += v.Z;
        }
        // Calculate average
        const avgX = sumX / vectors.length;
        const avgY = sumY / vectors.length;
        const avgZ = sumZ / vectors.length;
        return new Vector(avgX, avgY, avgZ);
    }
    return new Vector(0, 0, 0);
};
export const findClosestNumber = (numbers, value) => numbers.reduce(function (prev, curr) {
    return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
});
//# sourceMappingURL=math.js.map